let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8FXTk"), load("6wr18"), load("kjZZD"), load("ffEVr"), load("6KGrg"), load("4hZJd")]).then(() => parcelRequire('leLdu'));